import React from 'react'

const MessageIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Speech Bubble Outline and Tail */}
      <path d="M10.36,61.83l3.35-17.25H9.27a8.07,8.07,0,0,1-8.06-8.06v-22A8.07,8.07,0,0,1,9.27,6.47H54.73a8.07,8.07,0,0,1,8.06,8.06v22a8.07,8.07,0,0,1-8.06,8.06H26.87ZM9.27,10.33a4.21,4.21,0,0,0-4.2,4.2v22a4.21,4.21,0,0,0,4.2,4.2H18.4l-1.74,8.94,8.56-8.94H54.73a4.21,4.21,0,0,0,4.2-4.2v-22a4.21,4.21,0,0,0-4.2-4.2Z" />

      {/* Three Message Dots */}
      <circle cx="15.53" cy="25.05" r="5.25" />
      <circle cx="32" cy="25.05" r="5.25" />
      <circle cx="48.79" cy="25.05" r="5.25" />
    </svg>
  )
}

export default MessageIcon
